// An environment's VPN page (D80): reached from the task group's environment line (the org is
// in the link, `?org=`, since the environment record is a Platform page). The API decides
// who may see or change it.
import { useParams, useSearchParams } from "react-router";

import { VpnPanel } from "../vpn/VpnPanel";

export default function EnvironmentVpnPage() {
  const { envId } = useParams();
  const [params] = useSearchParams();
  const org = params.get("org");
  if (!envId || !org) return null;
  return <VpnPanel environmentId={envId} orgId={org} className="max-w-3xl" />;
}
